export const ACTION_CODE = 'DEALS' + '_ACTION';
